import { render, staticRenderFns } from "./VerInstitucion.vue?vue&type=template&id=9a5c5484&"
import script from "./VerInstitucion.vue?vue&type=script&lang=js&"
export * from "./VerInstitucion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports